(function () {
  'use strict';

  var namespace = 'GSJLiquidEther';
  var LIQUID_DEBUG = false;
  var DEBUG = false;
  var threePromise = null;
  var registry = window[namespace] && window[namespace].instances ? window[namespace].instances : new Map();
  var EXCLUDED_POINTER_TARGETS = [
    '[data-gsj-buy-card]',
    '.gsj-wwb-card',
    '.gsj-wwb-card *',
    '.gsj-wwb__eyebrow',
    '.gsj-wwb__heading',
    '.gsj-wwb__subtitle',
    '.gsj-wwb__trust',
    '.gsj-wwb__cta-copy',
    '.gsj-wwb__cta-copy *',
    '.gsj-wwb__button',
    '.gsj-wwb__button *',
    'a',
    'button',
    'input',
    'select',
    'textarea',
    '[role="button"]'
  ].join(',');

  var LIQUID_ETHER_CONFIG = {
    colors: ['#EAB308', '#F8D979', '#F4E0A0'],
    mouseForce: 20,
    cursorSize: 100,
    isViscous: true,
    viscous: 30,
    iterationsViscous: 32,
    iterationsPoisson: 32,
    dt: 0.014,
    BFECC: true,
    resolution: 0.5,
    isBounce: false,
    autoDemo: true,
    autoSpeed: 0.5,
    autoIntensity: 2.2,
    takeoverDuration: 0.25,
    autoResumeDelay: 3000,
    autoRampDuration: 0.6
  };

  function debug() {
    if (!(DEBUG || LIQUID_DEBUG) || !window.console) return;
    window.console.log.apply(window.console, arguments);
  }

  function warn(error) {
    if (!window.console) return;
    if (window.Shopify && window.Shopify.designMode) window.console.warn('GSJ LiquidEther failed:', error);
    else debug('GSJ LiquidEther failed:', error);
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function smoothstep(edge0, edge1, value) {
    var x = clamp((value - edge0) / Math.max(edge1 - edge0, 0.00001), 0, 1);
    return x * x * (3 - 2 * x);
  }

  function hexToRgb(hex) {
    var clean = String(hex || '#000000').replace('#', '').trim();
    if (clean.length === 3) clean = clean.split('').map(function (part) { return part + part; }).join('');
    var value = parseInt(clean, 16);
    if (Number.isNaN(value)) return [0, 0, 0, 255];
    return [(value >> 16) & 255, (value >> 8) & 255, value & 255, 255];
  }

  function loadThree(src) {
    if (window.THREE) return Promise.resolve(window.THREE);
    if (threePromise) return threePromise;
    threePromise = new Promise(function (resolve, reject) {
      var settled = false;
      var fallbackTimer = null;
      function finish(THREE) {
        if (settled) return;
        settled = true;
        if (fallbackTimer) window.clearTimeout(fallbackTimer);
        resolve(THREE);
      }
      function fail(error) {
        if (settled) return;
        settled = true;
        if (fallbackTimer) window.clearTimeout(fallbackTimer);
        reject(error);
      }
      function checkExisting() {
        if (window.THREE) finish(window.THREE);
      }
      function injectScript() {
        if (settled) return;
        if (window.THREE) {
          finish(window.THREE);
          return;
        }
        if (!src) {
          fail(new Error('Three.js asset URL missing'));
          return;
        }
        var script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.defer = true;
        script.setAttribute('data-gsj-three-loader', 'true');
        script.onload = function () {
          window.THREE ? finish(window.THREE) : fail(new Error('Three.js did not expose window.THREE'));
        };
        script.onerror = function () { fail(new Error('Three.js failed to load')); };
        document.head.appendChild(script);
      }
      var existing = document.querySelector('script[src*="three.min.js"], script[data-gsj-three-loader]');
      if (existing) {
        existing.addEventListener('load', checkExisting, { once: true });
        existing.addEventListener('error', function () { injectScript(); }, { once: true });
        checkExisting();
        window.setTimeout(checkExisting, 0);
        window.setTimeout(checkExisting, 60);
        fallbackTimer = window.setTimeout(injectScript, 220);
        return;
      }
      injectScript();
    });
    return threePromise;
  }

  var face_vert = [
    'precision highp float;',
    'attribute vec3 position;',
    'attribute vec2 uv;',
    'varying vec2 vUv;',
    'void main(){',
    '  vUv = uv;',
    '  gl_Position = vec4(position.xy, 0.0, 1.0);',
    '}'
  ].join('\n');

  var line_vert = face_vert;
  var mouse_vert = face_vert;

  var advection_frag = [
    'precision highp float;',
    'varying vec2 vUv;',
    'uniform sampler2D uVelocity;',
    'uniform vec2 uTexel;',
    'uniform float uDt;',
    'uniform float uBFECC;',
    'uniform float uDissipation;',
    'vec2 readVelocity(vec2 uv){ return texture2D(uVelocity, clamp(uv, 0.0, 1.0)).xy; }',
    'void main(){',
    '  vec2 velocity = readVelocity(vUv);',
    '  vec2 previousUv = vUv - velocity * uDt;',
    '  vec2 advected = readVelocity(previousUv);',
    '  if(uBFECC > 0.5){',
    '    vec2 forwardUv = previousUv + advected * uDt;',
    '    vec2 error = (vUv - forwardUv) * 0.5;',
    '    advected = readVelocity(previousUv + error);',
    '  }',
    '  gl_FragColor = vec4(advected * uDissipation, 0.0, 1.0);',
    '}'
  ].join('\n');

  var externalForce_frag = [
    'precision highp float;',
    'varying vec2 vUv;',
    'uniform sampler2D uVelocity;',
    'uniform vec2 uMouse;',
    'uniform vec2 uForce;',
    'uniform vec2 uAspect;',
    'uniform float uRadius;',
    'void main(){',
    '  vec2 velocity = texture2D(uVelocity, vUv).xy;',
    '  vec2 p = (vUv - uMouse) * uAspect;',
    '  float falloff = exp(-dot(p, p) / max(uRadius * uRadius, 0.00001));',
    '  velocity += uForce * falloff;',
    '  gl_FragColor = vec4(velocity, 0.0, 1.0);',
    '}'
  ].join('\n');

  var viscous_frag = [
    'precision highp float;',
    'varying vec2 vUv;',
    'uniform sampler2D uVelocity;',
    'uniform sampler2D uBaseVelocity;',
    'uniform vec2 uTexel;',
    'uniform float uViscous;',
    'uniform float uDt;',
    'void main(){',
    '  vec2 l = texture2D(uVelocity, vUv - vec2(uTexel.x, 0.0)).xy;',
    '  vec2 r = texture2D(uVelocity, vUv + vec2(uTexel.x, 0.0)).xy;',
    '  vec2 b = texture2D(uVelocity, vUv - vec2(0.0, uTexel.y)).xy;',
    '  vec2 t = texture2D(uVelocity, vUv + vec2(0.0, uTexel.y)).xy;',
    '  vec2 base = texture2D(uBaseVelocity, vUv).xy;',
    '  float amount = uDt * uViscous;',
    '  vec2 result = (base + amount * (l + r + b + t)) / (1.0 + 4.0 * amount);',
    '  gl_FragColor = vec4(result, 0.0, 1.0);',
    '}'
  ].join('\n');

  var divergence_frag = [
    'precision highp float;',
    'varying vec2 vUv;',
    'uniform sampler2D uVelocity;',
    'uniform vec2 uTexel;',
    'uniform float uIsBounce;',
    'void main(){',
    '  float l = texture2D(uVelocity, vUv - vec2(uTexel.x, 0.0)).x;',
    '  float r = texture2D(uVelocity, vUv + vec2(uTexel.x, 0.0)).x;',
    '  float b = texture2D(uVelocity, vUv - vec2(0.0, uTexel.y)).y;',
    '  float t = texture2D(uVelocity, vUv + vec2(0.0, uTexel.y)).y;',
    '  if(uIsBounce > 0.5){',
    '    vec2 center = texture2D(uVelocity, vUv).xy;',
    '    if(vUv.x <= uTexel.x) l = -center.x;',
    '    if(vUv.x >= 1.0 - uTexel.x) r = -center.x;',
    '    if(vUv.y <= uTexel.y) b = -center.y;',
    '    if(vUv.y >= 1.0 - uTexel.y) t = -center.y;',
    '  }',
    '  gl_FragColor = vec4(0.5 * (r - l + t - b), 0.0, 0.0, 1.0);',
    '}'
  ].join('\n');

  var poisson_frag = [
    'precision highp float;',
    'varying vec2 vUv;',
    'uniform sampler2D uPressure;',
    'uniform sampler2D uDivergence;',
    'uniform vec2 uTexel;',
    'void main(){',
    '  float l = texture2D(uPressure, vUv - vec2(uTexel.x, 0.0)).x;',
    '  float r = texture2D(uPressure, vUv + vec2(uTexel.x, 0.0)).x;',
    '  float b = texture2D(uPressure, vUv - vec2(0.0, uTexel.y)).x;',
    '  float t = texture2D(uPressure, vUv + vec2(0.0, uTexel.y)).x;',
    '  float div = texture2D(uDivergence, vUv).x;',
    '  gl_FragColor = vec4((l + r + b + t - div) * 0.25, 0.0, 0.0, 1.0);',
    '}'
  ].join('\n');

  var pressure_frag = [
    'precision highp float;',
    'varying vec2 vUv;',
    'uniform sampler2D uVelocity;',
    'uniform sampler2D uPressure;',
    'uniform vec2 uTexel;',
    'void main(){',
    '  float l = texture2D(uPressure, vUv - vec2(uTexel.x, 0.0)).x;',
    '  float r = texture2D(uPressure, vUv + vec2(uTexel.x, 0.0)).x;',
    '  float b = texture2D(uPressure, vUv - vec2(0.0, uTexel.y)).x;',
    '  float t = texture2D(uPressure, vUv + vec2(0.0, uTexel.y)).x;',
    '  vec2 velocity = texture2D(uVelocity, vUv).xy - vec2(r - l, t - b) * 0.5;',
    '  gl_FragColor = vec4(velocity, 0.0, 1.0);',
    '}'
  ].join('\n');

  var color_frag = [
    'precision highp float;',
    'varying vec2 vUv;',
    'uniform sampler2D uVelocity;',
    'uniform sampler2D uPalette;',
    'void main(){',
    '  vec2 velocity = texture2D(uVelocity, vUv).xy;',
    '  float energy = clamp(length(velocity) * 5.8, 0.0, 1.0);',
    '  vec3 color = texture2D(uPalette, vec2(energy, 0.5)).rgb;',
    '  float alpha = smoothstep(0.015, 0.72, energy) * 0.86;',
    '  gl_FragColor = vec4(color, alpha);',
    '}'
  ].join('\n');

  function Common(renderer, container, section, config) {
    this.renderer = renderer;
    this.container = container;
    this.section = section;
    this.config = config;
    this.width = 0;
    this.height = 0;
    this.simWidth = 0;
    this.simHeight = 0;
    this.texel = new window.THREE.Vector2(1, 1);
  }

  Common.prototype.measure = function () {
    var rect = this.container.getBoundingClientRect();
    if (!rect.width || !rect.height) rect = this.section.getBoundingClientRect();
    return rect;
  };

  Common.prototype.resize = function (force) {
    var rect = this.measure();
    if (rect.width <= 0 || rect.height <= 0) return false;
    var width = Math.max(1, Math.round(rect.width));
    var height = Math.max(1, Math.round(rect.height));
    var simWidth = Math.max(8, Math.round(width * this.config.resolution));
    var simHeight = Math.max(8, Math.round(height * this.config.resolution));
    var changed = force || width !== this.width || height !== this.height || simWidth !== this.simWidth || simHeight !== this.simHeight;
    if (!changed) return false;
    this.width = width;
    this.height = height;
    this.simWidth = simWidth;
    this.simHeight = simHeight;
    this.texel.set(1 / simWidth, 1 / simHeight);
    this.renderer.setSize(width, height, false);
    return true;
  };

  function Mouse(section, config) {
    this.section = section;
    this.config = config;
    this.coords = { x: 0.35, y: 0.65 };
    this.prev = { x: 0.35, y: 0.65 };
    this.diff = { x: 0, y: 0 };
    this.inside = false;
    this.moved = false;
    this.userControl = false;
    this.lastUserTime = 0;
    this.takeoverStart = 0;
    this.takeoverFrom = { x: 0.35, y: 0.65 };
  }

  Mouse.prototype.setFromAuto = function (x, y, dx, dy) {
    this.prev.x = this.coords.x;
    this.prev.y = this.coords.y;
    this.coords.x = x;
    this.coords.y = y;
    this.diff.x = dx;
    this.diff.y = dy;
    this.moved = true;
    this.userControl = false;
  };

  Mouse.prototype.updateFromEvent = function (event, rect, autoDriver) {
    var x = (event.clientX - rect.left) / Math.max(rect.width, 1);
    var y = 1 - ((event.clientY - rect.top) / Math.max(rect.height, 1));
    if (x < 0 || x > 1 || y < 0 || y > 1) return false;
    var now = performance.now();
    if (!this.userControl && autoDriver.active) {
      this.takeoverStart = now;
      this.takeoverFrom.x = autoDriver.x;
      this.takeoverFrom.y = autoDriver.y;
    }
    this.userControl = true;
    this.inside = true;
    this.lastUserTime = now;
    autoDriver.active = false;
    this.prev.x = this.coords.x;
    this.prev.y = this.coords.y;
    var progress = this.takeoverStart ? clamp((now - this.takeoverStart) / Math.max(this.config.takeoverDuration * 1000, 1), 0, 1) : 1;
    var eased = smoothstep(0, 1, progress);
    this.coords.x = this.takeoverStart ? this.takeoverFrom.x + (x - this.takeoverFrom.x) * eased : x;
    this.coords.y = this.takeoverStart ? this.takeoverFrom.y + (y - this.takeoverFrom.y) * eased : y;
    this.diff.x = this.coords.x - this.prev.x;
    this.diff.y = this.coords.y - this.prev.y;
    this.moved = true;
    return true;
  };

  Mouse.prototype.decay = function () {
    this.diff.x *= 0.82;
    this.diff.y *= 0.82;
    if (Math.abs(this.diff.x) < 0.00001 && Math.abs(this.diff.y) < 0.00001) {
      this.diff.x = 0;
      this.diff.y = 0;
      this.moved = false;
    }
  };

  function AutoDriver(config, mouse) {
    this.config = config;
    this.mouse = mouse;
    this.x = 0.35;
    this.y = 0.65;
    this.prevX = this.x;
    this.prevY = this.y;
    this.targetX = 0.72;
    this.targetY = 0.34;
    this.active = true;
    this.rampStart = performance.now();
  }

  AutoDriver.prototype.randomTarget = function () {
    return 0.14 + Math.random() * 0.72;
  };

  AutoDriver.prototype.update = function () {
    if (!this.config.autoDemo) return;
    var now = performance.now();
    if (this.mouse.userControl && now - this.mouse.lastUserTime < this.config.autoResumeDelay) return;
    if (!this.active) {
      this.active = true;
      this.rampStart = now;
      this.targetX = this.randomTarget();
      this.targetY = this.randomTarget();
      this.x = this.mouse.coords.x;
      this.y = this.mouse.coords.y;
      this.prevX = this.x;
      this.prevY = this.y;
    }
    var ramp = smoothstep(0, 1, (now - this.rampStart) / Math.max(this.config.autoRampDuration * 1000, 1));
    var speed = this.config.autoSpeed * 0.012 * ramp;
    var dx = this.targetX - this.x;
    var dy = this.targetY - this.y;
    var distance = Math.sqrt(dx * dx + dy * dy);
    if (distance < 0.035) {
      this.targetX = this.randomTarget();
      this.targetY = this.randomTarget();
      return;
    }
    this.prevX = this.x;
    this.prevY = this.y;
    this.x += (dx / Math.max(distance, 0.0001)) * speed;
    this.y += (dy / Math.max(distance, 0.0001)) * speed;
    this.mouse.setFromAuto(
      this.x,
      this.y,
      (this.x - this.prevX) * this.config.autoIntensity,
      (this.y - this.prevY) * this.config.autoIntensity
    );
  };

  function ShaderPass(THREE, common, fragmentShader, uniforms, vertexShader) {
    this.common = common;
    this.material = new THREE.RawShaderMaterial({
      vertexShader: vertexShader || face_vert,
      fragmentShader: fragmentShader,
      uniforms: uniforms || {},
      depthWrite: false,
      depthTest: false,
      transparent: true
    });
    this.mesh = new THREE.Mesh(new THREE.PlaneBufferGeometry(2, 2), this.material);
    this.scene = new THREE.Scene();
    this.scene.add(this.mesh);
  }

  ShaderPass.prototype.render = function (target) {
    this.common.renderer.setRenderTarget(target || null);
    this.common.renderer.render(this.scene, this.common.camera);
  };

  ShaderPass.prototype.dispose = function () {
    this.material.dispose();
    this.mesh.geometry.dispose();
  };

  function Advection(THREE, common, config) {
    ShaderPass.call(this, THREE, common, advection_frag, {
      uVelocity: { value: null },
      uTexel: { value: common.texel },
      uDt: { value: config.dt },
      uBFECC: { value: config.BFECC ? 1 : 0 },
      uDissipation: { value: 0.992 }
    }, face_vert);
  }
  Advection.prototype = Object.create(ShaderPass.prototype);
  Advection.prototype.constructor = Advection;
  Advection.prototype.update = function (velocity, target) {
    this.material.uniforms.uVelocity.value = velocity.texture;
    this.render(target);
  };

  function ExternalForce(THREE, common, config) {
    ShaderPass.call(this, THREE, common, externalForce_frag, {
      uVelocity: { value: null },
      uMouse: { value: new THREE.Vector2(0.5, 0.5) },
      uForce: { value: new THREE.Vector2(0, 0) },
      uAspect: { value: new THREE.Vector2(1, 1) },
      uRadius: { value: 0.08 }
    }, mouse_vert);
    this.config = config;
  }
  ExternalForce.prototype = Object.create(ShaderPass.prototype);
  ExternalForce.prototype.constructor = ExternalForce;
  ExternalForce.prototype.update = function (velocity, mouse, target) {
    var forceX = (mouse.diff.x / 2) * this.config.mouseForce;
    var forceY = (mouse.diff.y / 2) * this.config.mouseForce;
    this.material.uniforms.uVelocity.value = velocity.texture;
    this.material.uniforms.uMouse.value.set(mouse.coords.x, mouse.coords.y);
    this.material.uniforms.uForce.value.set(forceX, forceY);
    this.material.uniforms.uAspect.value.set(this.common.width / Math.max(this.common.height, 1), 1);
    this.material.uniforms.uRadius.value = clamp(this.config.cursorSize / Math.max(this.common.width, this.common.height), 0.015, 0.35);
    this.render(target);
  };

  function Viscous(THREE, common, config) {
    ShaderPass.call(this, THREE, common, viscous_frag, {
      uVelocity: { value: null },
      uBaseVelocity: { value: null },
      uTexel: { value: common.texel },
      uViscous: { value: config.viscous },
      uDt: { value: config.dt }
    }, face_vert);
    this.config = config;
  }
  Viscous.prototype = Object.create(ShaderPass.prototype);
  Viscous.prototype.constructor = Viscous;
  Viscous.prototype.update = function (velocity, baseVelocity, target) {
    this.material.uniforms.uVelocity.value = velocity.texture;
    this.material.uniforms.uBaseVelocity.value = baseVelocity.texture;
    this.render(target);
  };

  function Divergence(THREE, common, config) {
    ShaderPass.call(this, THREE, common, divergence_frag, {
      uVelocity: { value: null },
      uTexel: { value: common.texel },
      uIsBounce: { value: config.isBounce ? 1 : 0 }
    }, line_vert);
  }
  Divergence.prototype = Object.create(ShaderPass.prototype);
  Divergence.prototype.constructor = Divergence;
  Divergence.prototype.update = function (velocity, target) {
    this.material.uniforms.uVelocity.value = velocity.texture;
    this.render(target);
  };

  function Poisson(THREE, common) {
    ShaderPass.call(this, THREE, common, poisson_frag, {
      uPressure: { value: null },
      uDivergence: { value: null },
      uTexel: { value: common.texel }
    }, face_vert);
  }
  Poisson.prototype = Object.create(ShaderPass.prototype);
  Poisson.prototype.constructor = Poisson;
  Poisson.prototype.update = function (pressure, divergence, target) {
    this.material.uniforms.uPressure.value = pressure.texture;
    this.material.uniforms.uDivergence.value = divergence.texture;
    this.render(target);
  };

  function Pressure(THREE, common) {
    ShaderPass.call(this, THREE, common, pressure_frag, {
      uVelocity: { value: null },
      uPressure: { value: null },
      uTexel: { value: common.texel }
    }, face_vert);
  }
  Pressure.prototype = Object.create(ShaderPass.prototype);
  Pressure.prototype.constructor = Pressure;
  Pressure.prototype.update = function (velocity, pressure, target) {
    this.material.uniforms.uVelocity.value = velocity.texture;
    this.material.uniforms.uPressure.value = pressure.texture;
    this.render(target);
  };

  function Output(THREE, common, config) {
    ShaderPass.call(this, THREE, common, color_frag, {
      uVelocity: { value: null },
      uPalette: { value: null }
    }, face_vert);
    this.THREE = THREE;
    this.config = config;
    this.paletteTexture = null;
    this.createPaletteTexture();
  }
  Output.prototype = Object.create(ShaderPass.prototype);
  Output.prototype.constructor = Output;
  Output.prototype.createPaletteTexture = function () {
    var THREE = this.THREE;
    var colors = this.config.colors;
    var data = new Uint8Array(colors.length * 4);
    colors.forEach(function (color, index) {
      var rgb = hexToRgb(color);
      data[index * 4] = rgb[0];
      data[index * 4 + 1] = rgb[1];
      data[index * 4 + 2] = rgb[2];
      data[index * 4 + 3] = 255;
    });
    this.paletteTexture = new THREE.DataTexture(data, colors.length, 1, THREE.RGBAFormat);
    this.paletteTexture.minFilter = THREE.LinearFilter;
    this.paletteTexture.magFilter = THREE.LinearFilter;
    this.paletteTexture.wrapS = THREE.ClampToEdgeWrapping;
    this.paletteTexture.wrapT = THREE.ClampToEdgeWrapping;
    this.paletteTexture.generateMipmaps = false;
    this.paletteTexture.needsUpdate = true;
    this.material.uniforms.uPalette.value = this.paletteTexture;
  };
  Output.prototype.update = function (velocity) {
    this.material.uniforms.uVelocity.value = velocity.texture;
    this.render(null);
  };
  Output.prototype.dispose = function () {
    if (this.paletteTexture) this.paletteTexture.dispose();
    ShaderPass.prototype.dispose.call(this);
  };

  function Simulation(THREE, common, config, targetOptions) {
    this.THREE = THREE;
    this.common = common;
    this.config = config;
    this.targetOptions = targetOptions;
    this.targets = {};
    this.advection = new Advection(THREE, common, config);
    this.externalForce = new ExternalForce(THREE, common, config);
    this.viscous = new Viscous(THREE, common, config);
    this.divergence = new Divergence(THREE, common, config);
    this.poisson = new Poisson(THREE, common);
    this.pressure = new Pressure(THREE, common);
  }

  Simulation.prototype.createTarget = function () {
    return new this.THREE.WebGLRenderTarget(this.common.simWidth, this.common.simHeight, this.targetOptions);
  };

  Simulation.prototype.resize = function () {
    this.disposeTargets();
    this.targets.vel_0 = this.createTarget();
    this.targets.vel_1 = this.createTarget();
    this.targets.vel_viscous0 = this.createTarget();
    this.targets.vel_viscous1 = this.createTarget();
    this.targets.div = this.createTarget();
    this.targets.pressure_0 = this.createTarget();
    this.targets.pressure_1 = this.createTarget();
    this.clearTargets();
  };

  Simulation.prototype.clearTargets = function () {
    var renderer = this.common.renderer;
    Object.keys(this.targets).forEach(function (key) {
      renderer.setRenderTarget(this.targets[key]);
      renderer.clear();
    }, this);
    renderer.setRenderTarget(null);
  };

  Simulation.prototype.swap = function (a, b) {
    var temp = this.targets[a];
    this.targets[a] = this.targets[b];
    this.targets[b] = temp;
  };

  Simulation.prototype.step = function (mouse) {
    if (!this.targets.vel_0) return this.targets.vel_0;
    this.advection.update(this.targets.vel_0, this.targets.vel_1);
    this.swap('vel_0', 'vel_1');

    if (mouse.moved || Math.abs(mouse.diff.x) > 0 || Math.abs(mouse.diff.y) > 0) {
      this.externalForce.update(this.targets.vel_0, mouse, this.targets.vel_1);
      this.swap('vel_0', 'vel_1');
    }

    if (this.config.isViscous) {
      var readKey = 'vel_0';
      var writeKey = 'vel_viscous0';
      for (var i = 0; i < this.config.iterationsViscous; i += 1) {
        this.viscous.update(this.targets[readKey], this.targets.vel_0, this.targets[writeKey]);
        var tempKey = readKey;
        readKey = writeKey;
        writeKey = tempKey === 'vel_0' ? 'vel_viscous1' : tempKey;
      }
      if (readKey !== 'vel_0') {
        var current = this.targets.vel_0;
        this.targets.vel_0 = this.targets[readKey];
        this.targets[readKey] = current;
      }
    }

    this.divergence.update(this.targets.vel_0, this.targets.div);
    for (var p = 0; p < this.config.iterationsPoisson; p += 1) {
      this.poisson.update(this.targets.pressure_0, this.targets.div, this.targets.pressure_1);
      this.swap('pressure_0', 'pressure_1');
    }
    this.pressure.update(this.targets.vel_0, this.targets.pressure_0, this.targets.vel_1);
    this.swap('vel_0', 'vel_1');
    return this.targets.vel_0;
  };

  Simulation.prototype.disposeTargets = function () {
    Object.keys(this.targets).forEach(function (key) {
      if (this.targets[key]) this.targets[key].dispose();
    }, this);
    this.targets = {};
  };

  Simulation.prototype.dispose = function () {
    this.disposeTargets();
    [this.advection, this.externalForce, this.viscous, this.divergence, this.poisson, this.pressure].forEach(function (pass) {
      if (pass) pass.dispose();
    });
  };

  function WebGLManager(section, container, THREE, config) {
    this.section = section;
    this.container = container;
    this.THREE = THREE;
    this.config = config;
    this.renderer = null;
    this.common = null;
    this.mouse = null;
    this.autoDriver = null;
    this.simulation = null;
    this.output = null;
    this.raf = null;
    this.resizeRaf = null;
    this.resizeObserver = null;
    this.intersectionObserver = null;
    this.visible = true;
    this.destroyed = false;
    this.started = false;
    this.frameCount = 0;
    this.lastPointerAccepted = false;
    this.lastPointerExcluded = false;
    this.targetOptions = null;
    this.onPointerMove = this.onPointerMove.bind(this);
    this.onPointerLeave = this.onPointerLeave.bind(this);
    this.onVisibility = this.onVisibility.bind(this);
    this.queueResize = this.queueResize.bind(this);
    this.tick = this.tick.bind(this);
  }

  WebGLManager.prototype.init = function () {
    var THREE = this.THREE;
    this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    this.renderer.autoClear = false;
    this.renderer.setClearColor(new THREE.Color(0x000000), 0);
    this.renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    this.common = new Common(this.renderer, this.container, this.section, this.config);
    this.common.camera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
    this.targetOptions = this.detectTargetOptions();
    if (!this.targetOptions) throw new Error('No supported fluid render target type');
    this.container.innerHTML = '';
    this.container.appendChild(this.renderer.domElement);
    this.mouse = new Mouse(this.section, this.config);
    this.autoDriver = new AutoDriver(this.config, this.mouse);
    this.simulation = new Simulation(THREE, this.common, {
      iterations_poisson: 32,
      iterations_viscous: 32,
      mouse_force: 20,
      resolution: 0.5,
      cursor_size: 100,
      viscous: 30,
      isBounce: false,
      dt: 0.014,
      isViscous: true,
      BFECC: true,
      iterationsPoisson: this.config.iterationsPoisson,
      iterationsViscous: this.config.iterationsViscous,
      mouseForce: this.config.mouseForce,
      cursorSize: this.config.cursorSize
    }, this.targetOptions);
    this.output = new Output(THREE, this.common, this.config);
    if (!this.common.resize(true)) throw new Error('LiquidEther container has no dimensions');
    this.simulation.resize();
    this.bind();
    this.section.classList.remove('is-liquid-fallback', 'is-liquid-reduced-motion');
    this.section.classList.add('is-liquid-ready');
    this.start();
  };

  WebGLManager.prototype.testTargetOptions = function (options) {
    var THREE = this.THREE;
    var gl = this.renderer.getContext();
    var previous = this.renderer.getRenderTarget ? this.renderer.getRenderTarget() : null;
    var target = null;
    try {
      target = new THREE.WebGLRenderTarget(4, 4, options);
      this.renderer.setRenderTarget(target);
      this.renderer.clear();
      return !gl.checkFramebufferStatus || gl.checkFramebufferStatus(gl.FRAMEBUFFER) === gl.FRAMEBUFFER_COMPLETE;
    } catch (error) {
      debug('GSJ LiquidEther render target probe failed', error);
      return false;
    } finally {
      this.renderer.setRenderTarget(previous);
      if (target) target.dispose();
    }
  };

  WebGLManager.prototype.detectTargetOptions = function () {
    var THREE = this.THREE;
    var extensions = this.renderer.extensions;
    var isWebGL2 = this.renderer.capabilities && this.renderer.capabilities.isWebGL2;
    var base = {
      format: THREE.RGBAFormat,
      wrapS: THREE.ClampToEdgeWrapping,
      wrapT: THREE.ClampToEdgeWrapping,
      depthBuffer: false,
      stencilBuffer: false
    };
    var candidates = [];
    function push(type, filter, label) {
      if (!type || !filter) return;
      candidates.push(Object.assign({}, base, {
        type: type,
        minFilter: filter,
        magFilter: filter,
        label: label
      }));
    }
    var hasFloatTexture = isWebGL2 || !!extensions.get('OES_texture_float');
    var hasFloatRenderable = isWebGL2 ? !!extensions.get('EXT_color_buffer_float') : !!(extensions.get('WEBGL_color_buffer_float') || extensions.get('EXT_color_buffer_float'));
    var hasHalfTexture = isWebGL2 || !!extensions.get('OES_texture_half_float');
    var hasHalfRenderable = isWebGL2 ? !!(extensions.get('EXT_color_buffer_float') || extensions.get('EXT_color_buffer_half_float')) : !!extensions.get('EXT_color_buffer_half_float');
    if (hasFloatTexture && hasFloatRenderable) {
      push(THREE.FloatType, extensions.get('OES_texture_float_linear') ? THREE.LinearFilter : THREE.NearestFilter, 'float');
      push(THREE.FloatType, THREE.NearestFilter, 'float-nearest');
    }
    if (hasHalfTexture && hasHalfRenderable) {
      push(THREE.HalfFloatType, extensions.get('OES_texture_half_float_linear') ? THREE.LinearFilter : THREE.NearestFilter, 'half-float');
      push(THREE.HalfFloatType, THREE.NearestFilter, 'half-float-nearest');
    }
    for (var i = 0; i < candidates.length; i += 1) {
      if (this.testTargetOptions(candidates[i])) {
        debug('GSJ LiquidEther target mode', candidates[i].label);
        return candidates[i];
      }
    }
    return null;
  };

  WebGLManager.prototype.bind = function () {
    this.section.addEventListener('pointermove', this.onPointerMove, { passive: true });
    this.section.addEventListener('pointerleave', this.onPointerLeave, { passive: true });
    document.addEventListener('visibilitychange', this.onVisibility);
    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(this.queueResize);
      this.resizeObserver.observe(this.section);
      this.resizeObserver.observe(this.container);
    } else {
      window.addEventListener('resize', this.queueResize, { passive: true });
    }
    if (window.IntersectionObserver) {
      var self = this;
      this.intersectionObserver = new IntersectionObserver(function (entries) {
        if (!entries || !entries[0]) return;
        self.visible = entries[0].isIntersecting || entries[0].intersectionRatio > 0;
        self.visible && !document.hidden ? self.start() : self.stop();
      }, { rootMargin: '200px 0px', threshold: 0.01 });
      this.intersectionObserver.observe(this.section);
    }
  };

  WebGLManager.prototype.onPointerMove = function (event) {
    if (!this.acceptsPointer(event)) {
      this.lastPointerAccepted = false;
      this.lastPointerExcluded = true;
      return;
    }
    this.lastPointerAccepted = true;
    this.lastPointerExcluded = false;
    this.mouse.updateFromEvent(event, this.section.getBoundingClientRect(), this.autoDriver);
  };

  WebGLManager.prototype.acceptsPointer = function (event) {
    if (event.pointerType && event.pointerType !== 'mouse' && event.pointerType !== 'pen') return false;
    var target = event.target;
    var pointTarget = null;
    if (document.elementFromPoint) pointTarget = document.elementFromPoint(event.clientX, event.clientY);
    var tested = pointTarget instanceof Element ? pointTarget : target;
    if (tested instanceof Element && tested.closest(EXCLUDED_POINTER_TARGETS)) {
      if (LIQUID_DEBUG) debug('GSJ LiquidEther pointer excluded', tested.tagName, tested.className || tested.id || tested.getAttribute('data-gsj-buy-card'));
      return false;
    }
    return true;
  };

  WebGLManager.prototype.onPointerLeave = function () {
    this.mouse.inside = false;
  };

  WebGLManager.prototype.queueResize = function () {
    if (this.resizeRaf || this.destroyed) return;
    var self = this;
    this.resizeRaf = window.requestAnimationFrame(function () {
      self.resizeRaf = null;
      if (self.common && self.common.resize(false) && self.simulation) self.simulation.resize();
    });
  };

  WebGLManager.prototype.onVisibility = function () {
    document.hidden || !this.visible ? this.stop() : this.start();
  };

  WebGLManager.prototype.tick = function () {
    if (this.destroyed || !this.started) return;
    this.frameCount += 1;
    this.autoDriver.update();
    var velocity = this.simulation.step(this.mouse);
    this.output.update(velocity);
    this.mouse.decay();
    this.raf = window.requestAnimationFrame(this.tick);
  };

  WebGLManager.prototype.start = function () {
    if (this.started || this.destroyed || document.hidden || !this.visible) return;
    this.started = true;
    this.raf = window.requestAnimationFrame(this.tick);
  };

  WebGLManager.prototype.stop = function () {
    this.started = false;
    if (this.raf) window.cancelAnimationFrame(this.raf);
    this.raf = null;
  };

  WebGLManager.prototype.destroy = function () {
    this.destroyed = true;
    this.stop();
    if (this.resizeRaf) window.cancelAnimationFrame(this.resizeRaf);
    this.section.removeEventListener('pointermove', this.onPointerMove);
    this.section.removeEventListener('pointerleave', this.onPointerLeave);
    document.removeEventListener('visibilitychange', this.onVisibility);
    window.removeEventListener('resize', this.queueResize);
    if (this.resizeObserver) this.resizeObserver.disconnect();
    if (this.intersectionObserver) this.intersectionObserver.disconnect();
    if (this.simulation) this.simulation.dispose();
    if (this.output) this.output.dispose();
    if (this.renderer) {
      this.renderer.dispose();
      if (this.renderer.forceContextLoss) this.renderer.forceContextLoss();
      if (this.renderer.domElement && this.renderer.domElement.parentNode) this.renderer.domElement.parentNode.removeChild(this.renderer.domElement);
    }
    this.container.innerHTML = '';
    this.section.classList.remove('is-liquid-ready', 'is-liquid-fallback', 'is-liquid-reduced-motion');
  };

  function GSJLiquidEtherInstance(section) {
    this.section = section;
    this.container = section.querySelector('[data-gsj-liquid-ether]');
    this.manager = null;
    this.destroyed = false;
    this.retryCount = 0;
  }

  GSJLiquidEtherInstance.prototype.prefersReducedMotion = function () {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  GSJLiquidEtherInstance.prototype.init = function () {
    if (!this.container) return;
    if (this.prefersReducedMotion()) {
      this.section.classList.add('is-liquid-reduced-motion');
      return;
    }
    this.waitForSize();
  };

  GSJLiquidEtherInstance.prototype.waitForSize = function () {
    if (this.destroyed) return;
    var rect = this.container.getBoundingClientRect();
    if (rect.width > 0 && rect.height > 0) {
      this.load();
      return;
    }
    this.retryCount += 1;
    if (this.retryCount > 90) {
      this.applyFallback(new Error('LiquidEther mount never received dimensions'));
      return;
    }
    window.requestAnimationFrame(this.waitForSize.bind(this));
  };

  GSJLiquidEtherInstance.prototype.load = function () {
    var self = this;
    var threeSrc = this.section.getAttribute('data-gsj-liquid-three-src') || '';
    loadThree(threeSrc).then(function (THREE) {
      if (self.destroyed) return;
      try {
        self.manager = new WebGLManager(self.section, self.container, THREE, LIQUID_ETHER_CONFIG);
        self.manager.init();
      } catch (error) {
        if (self.manager) self.manager.destroy();
        self.manager = null;
        self.applyFallback(error);
      }
    }).catch(function (error) {
      self.applyFallback(error);
    });
  };

  GSJLiquidEtherInstance.prototype.applyFallback = function (error) {
    warn(error);
    if (this.container) this.container.innerHTML = '';
    this.section.classList.add('is-liquid-fallback');
    this.section.classList.remove('is-liquid-ready');
  };

  GSJLiquidEtherInstance.prototype.destroy = function () {
    this.destroyed = true;
    if (this.manager) this.manager.destroy();
    if (this.container) this.container.innerHTML = '';
  };

  function sectionsFrom(root) {
    if (!root) root = document;
    var sections = [];
    var selector = '[data-gsj-buy-gallery], [data-gsj-wwb]';
    if (root.matches && root.matches(selector)) sections.push(root);
    if (root.querySelectorAll) {
      Array.prototype.slice.call(root.querySelectorAll(selector)).forEach(function (section) {
        if (sections.indexOf(section) === -1) sections.push(section);
      });
    }
    return sections;
  }

  function init(root) {
    sectionsFrom(root).forEach(function (section) {
      var id = section.id || section.getAttribute('data-section-id');
      if (!id) return;
      if (registry.has(id)) {
        registry.get(id).destroy();
        registry.delete(id);
      }
      var instance = new GSJLiquidEtherInstance(section);
      registry.set(id, instance);
      instance.init();
    });
  }

  function destroy(root) {
    sectionsFrom(root).forEach(function (section) {
      var id = section.id || section.getAttribute('data-section-id');
      if (id && registry.has(id)) {
        registry.get(id).destroy();
        registry.delete(id);
      }
    });
  }

  function diagnostics(root) {
    return sectionsFrom(root).map(function (section) {
      var id = section.id || section.getAttribute('data-section-id');
      var instance = id && registry.has(id) ? registry.get(id) : null;
      var manager = instance && instance.manager;
      var mount = section.querySelector('[data-gsj-liquid-ether]');
      var canvas = mount && mount.querySelector('canvas');
      var sectionRect = section.getBoundingClientRect();
      var mountRect = mount ? mount.getBoundingClientRect() : null;
      return {
        id: id,
        hasInstance: !!instance,
        hasManager: !!manager,
        ready: section.classList.contains('is-liquid-ready'),
        fallback: section.classList.contains('is-liquid-fallback'),
        canvasCount: mount ? mount.querySelectorAll('canvas').length : 0,
        canvasWidth: canvas ? canvas.width : 0,
        canvasHeight: canvas ? canvas.height : 0,
        sectionWidth: sectionRect.width,
        sectionHeight: sectionRect.height,
        mountWidth: mountRect ? mountRect.width : 0,
        mountHeight: mountRect ? mountRect.height : 0,
        simWidth: manager && manager.common ? manager.common.simWidth : 0,
        simHeight: manager && manager.common ? manager.common.simHeight : 0,
        frameCount: manager ? manager.frameCount : 0,
        autoActive: manager && manager.autoDriver ? manager.autoDriver.active : false,
        pointerInside: manager && manager.mouse ? manager.mouse.inside : false,
        pointerDiff: manager && manager.mouse ? { x: manager.mouse.diff.x, y: manager.mouse.diff.y } : { x: 0, y: 0 },
        pointerAccepted: manager ? manager.lastPointerAccepted : false,
        pointerExcluded: manager ? manager.lastPointerExcluded : false,
        colors: LIQUID_ETHER_CONFIG.colors.slice(),
        iterationsViscous: LIQUID_ETHER_CONFIG.iterationsViscous,
        iterationsPoisson: LIQUID_ETHER_CONFIG.iterationsPoisson,
        isViscous: LIQUID_ETHER_CONFIG.isViscous,
        BFECC: LIQUID_ETHER_CONFIG.BFECC,
        resolution: LIQUID_ETHER_CONFIG.resolution,
        dt: LIQUID_ETHER_CONFIG.dt,
        targetType: manager && manager.targetOptions ? manager.targetOptions.label || '' : ''
      };
    });
  }

  window[namespace] = {
    instances: registry,
    config: LIQUID_ETHER_CONFIG,
    init: init,
    destroy: destroy,
    diagnostics: diagnostics
  };

  if (!window.GSJLiquidEtherEventsBound) {
    window.GSJLiquidEtherEventsBound = true;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
    document.addEventListener('shopify:section:unload', function (event) { destroy(event.target); });
  }
})();
